import { Box, styled, SxProps, Theme, Typography } from '@mui/material';
import { FC } from 'react';

interface Props {
  label: string;
  value: string | number | null;
  sx?: SxProps<Theme>;
}

const Container = styled(Box)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: ${(props) => props.theme.spacing(1)}px;
  height: 48px;
`;

const Label = styled(Typography)`
  font-weight: bold;
  font-size: 20px;
`;

const Value = styled(Typography)`
  margin-left: 8px;
  font-size: 20px;
`;

export const LabelWithValue: FC<Props> = ({ label, value, sx }) => {
  return (
    <Container sx={sx}>
      <Label>{label}:</Label>
      <Value>{value ?? 'not set'}</Value>
    </Container>
  );
};
